import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class HideViewsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('hideViews', { ids: ids });
  }
}
